import type { MouseEventHandler } from "react";
import { t } from "@/i18n-js/instance";
import { useMemberFilterDesign } from "@/react/components/shared/FilterV3/MemberFilterDesignContext";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";

export const ClearButton = ({
  isVisible = true,
  onClick,
}: {
  isVisible: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}) => {
  const isMemberFilterDesignEnabled = useMemberFilterDesign();

  return (
    <button
      type="submit"
      className={
        isMemberFilterDesignEnabled
          ? classNames(
              "hover:bg-secondary inline-flex items-center justify-center gap-2 self-start rounded-3xl px-3 py-1.5",
              { invisible: !isVisible },
            )
          : classNames("text-light hover:text-darkest flex text-sm", {
              invisible: !isVisible,
            })
      }
      disabled={!isVisible}
      onClick={onClick}
    >
      {isMemberFilterDesignEnabled ? (
        <span className="text-dark text-center text-sm font-medium leading-5 underline">
          {t("clear")}
        </span>
      ) : (
        <>
          <Icon
            type="20-close-sm"
            size={20}
            useWithFillCurrentColor
            aria-hidden
          />
          <p>{t("filters.clear_filters")}</p>
        </>
      )}
    </button>
  );
};
